/* sv-cart-track (2026-09-25): pomiar koszyka (prezent PonyGadget + „Dopełnij zestaw”) -> GA4, dataLayer, Shopify.analytics.
   - gtag wstrzykuje kanał Google & YouTube z opóźnieniem -> kolejka, max ~10 min;
   - dataLayer i GA4 tylko przy zgodzie analitycznej (K3 03.10, jak assets/sv-events.js); publish zawsze;
   - własny `config` strumienia z send_page_view:false (bez zmian).
   Zdarzenia: sv_xsell_view / sv_xsell_seen / sv_xsell_color / sv_xsell_add, sv_gift_auto_add / sv_gift_change / sv_gift_remove /
   sv_gift_restore.
   Parametry: context, product, badge, position, color, action (wymiary GA4 zarejestrowane 25.09). */
(function () {
  if (window.svCartTrack) return;
  var GA4_ID = 'G-FKYK3H94J2';
  /* zgoda (03.10, K3; wzorzec assets/sv-events.js): dataLayer i GA4 tylko przy zgodzie analitycznej z Shopify Customer
     Privacy API. Zdarzenie sprzed decyzji w banerze czeka w kolejce (max ok. 10 min) i idzie po „Akceptuj” (1 s po zgodzie,
     żeby Consentmo zdążył zaktualizować tryb zgody gtag); „Odrzuć” albo brak decyzji przez 10 min = kolejka wyczyszczona.
     Wcześniej: GA4 po DOWOLNEJ decyzji (także po „Odrzuć”, wtedy hity bez cookies), dataLayer zawsze. K4 (04.10): zgoda sprzed wejścia na stronę (baner nie czekał w tej wizycie) = bez czekania 1 s (wzór sv-quiz). */
  var ga4Ready = false, gaQueue = [], gaPoll = null, gaTries = 0, consentYesAt = 0, consentWaited = false;
  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'na';
    try {
      if (cp.analyticsProcessingAllowed()) return 'yes';
      var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c && c.analytics === 'no' ? 'no' : '';
    } catch (e) { return 'na'; }
  }
  function gaFlush() {
    var st = consentState();
    if (st === '') consentWaited = true;
    if (st === 'no') { gaQueue.length = 0; return true; }
    if (st !== 'yes') return false;
    if (consentWaited) {
      if (!consentYesAt) consentYesAt = Date.now();
      if (Date.now() - consentYesAt < 1000) return false;
    }
    for (var i = 0; i < gaQueue.length; i++) {
      if (gaQueue[i].dl) continue;
      gaQueue[i].dl = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: gaQueue[i].name }, gaQueue[i].data));
      } catch (e) {}
    }
    if (typeof window.gtag !== 'function') return false;
    if (!ga4Ready) { window.gtag('config', GA4_ID, { send_page_view: false }); ga4Ready = true; }
    while (gaQueue.length) {
      var q = gaQueue.shift();
      try { window.gtag('event', q.name, Object.assign({ send_to: GA4_ID }, q.data)); } catch (e) {}
    }
    return true;
  }
  function gaSend(name, data) {
    gaQueue.push({ name: name, data: data, dl: false });
    if (gaFlush() || gaPoll) return;
    gaTries = 0;
    gaPoll = setInterval(function () {
      gaTries++;
      if (gaFlush() || gaTries > 2400) { clearInterval(gaPoll); gaPoll = null; gaQueue.length = 0; }
    }, 250);
  }
  function track(name, data) {
    var payload = {};
    Object.keys(data || {}).forEach(function (k) {
      if (data[k] !== undefined && data[k] !== null && data[k] !== '') payload[k] = data[k];
    });
    try { gaSend(name, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('skinvibe_' + name.replace(/^sv_/, ''), payload);
      }
    } catch (e) {}
  }
  window.svCartTrack = track;

  /* ---------- „Dopełnij zestaw” ---------- */
  function visible(el) {
    return !!el && el.getClientRects().length > 0 && !el.closest('[hidden]');
  }
  /* widoczna sekcja w otwartej szufladzie (kopia wstawiona między pozycje albo pusty koszyk) */
  function openSection() {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.classList.contains('active')) return null;
    var list = [].slice.call(d.querySelectorAll('.cart-drawer-upsell-list[data-xsell-smart]')).filter(visible)[0];
    return list || null;
  }
  function cardData(card) {
    var list = card.closest('.cart-drawer-upsell-list');
    var cards = [].slice.call(list.querySelectorAll('.sv-xs-card')).filter(function (c) { return !c.hidden; });
    var chk = card.querySelector('input[data-xs-variant]:checked');
    var name = card.querySelector('.cart-item__name');
    return {
      /* K2 przegląd W6: karty na /cart stoją też pod podsumowaniem (#main-cart-footer, telefon); pusty /cart = empty */
      context: card.closest('#cart-empty-upsell, #cart-page-empty-upsell') ? 'empty' : card.closest('cart-items, #main-cart-footer') ? 'cart_page' : card.dataset.xsellContext || '',
      product: name ? name.textContent.trim() : '',
      badge: card.dataset.xsellBadge || 'none',
      position: cards.indexOf(card) + 1,
      color: chk ? chk.dataset.value : ''
    };
  }
  /* parametry widoku sekcji: kontekst pierwszej karty, widoczne produkty i plakietki (wspólne dla sv_xsell_view i sv_xsell_seen) */
  function viewParams(list) {
    var cards = [].slice.call(list.querySelectorAll('.sv-xs-card')).filter(function (c) { return !c.hidden; });
    if (!cards.length) return null;
    return {
      context: cardData(cards[0]).context,
      product: cards.map(function (c) { return cardData(c).product; }).join(' | '),
      badge: cards.map(function (c) { return c.dataset.xsellBadge || 'none'; }).join(' | ')
    };
  }
  /* widok: raz na każde otwarcie szuflady, gdy sekcja jest wyrenderowana (nie musi być na ekranie) */
  var viewedThisOpen = false;
  function checkView() {
    var list = openSection();
    if (!list || viewedThisOpen) return;
    var params = viewParams(list);
    if (!params) return;
    viewedThisOpen = true;
    track('sv_xsell_view', params);
  }
  /* T6 (01.10, T2 §5): „zobaczono” = pierwsza karta naprawdę na ekranie, raz na otwarcie szuflady. IntersectionObserver
     z korzeniem = przewijana część szuflady (.cart-drawer-items-wrapper; pusty koszyk: .drawer__inner-empty), bez nasłuchu
     przewijania w głównym wątku. Próg: ≥ 50 % karty, a gdy karta jest wyższa niż widoczna część szuflady (iPhone SE w Safari:
     ok. 190 px przy karcie ok. 420 px) - ≥ 50 % widocznej części. Te same parametry co sv_xsell_view, ta sama ścieżka zgody
     (track: dataLayer i GA4 po zgodzie analitycznej, Shopify.analytics.publish zawsze). */
  var seenThisOpen = false, seenIO = null, seenCard = null;
  function stopSeen() {
    if (seenIO) seenIO.disconnect();
    seenIO = null;
    seenCard = null;
  }
  function armSeen() {
    if (seenThisOpen || typeof IntersectionObserver !== 'function') return;
    var list = openSection();
    var first = list && list.querySelector('.sv-xs-card:not([hidden])');
    if (!first || (first === seenCard && seenIO)) return;
    stopSeen();
    seenCard = first;
    var root = list.closest('.cart-drawer-items-wrapper, .drawer__inner-empty');
    seenIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (seenThisOpen || !e.isIntersecting) return;
        var visibleArea = e.rootBounds ? Math.min(e.boundingClientRect.height, e.rootBounds.height) : e.boundingClientRect.height;
        if (e.intersectionRect.height < 0.5 * visibleArea - 1) return;
        var l = openSection();
        var params = l && viewParams(l);
        if (!params) return;
        seenThisOpen = true;
        stopSeen();
        track('sv_xsell_seen', params);
      });
    }, { root: root || null, threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5] });
    seenIO.observe(first);
  }
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.__svTrack) return;
    d.__svTrack = true;
    new MutationObserver(function () {
      if (!d.classList.contains('active')) { viewedThisOpen = false; seenThisOpen = false; stopSeen(); return; }
      setTimeout(function () { checkView(); armSeen(); }, 600);
      setTimeout(function () { checkView(); armSeen(); }, 1800);
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    /* kopia sekcji podmieniona przy otwartej szufladzie (zmiana ilości, prezent) - obserwacja nowej karty przy przewinięciu */
    d.addEventListener('scroll', function () {
      if (!seenThisOpen && d.classList.contains('active') && (!seenCard || !seenCard.isConnected)) armSeen();
    }, { capture: true, passive: true });
    if (d.classList.contains('active')) setTimeout(function () { checkView(); armSeen(); }, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  /* zmiana koloru przez klientkę (tylko zdarzenie z interfejsu) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!e.isTrusted || !t || !t.matches || !t.matches('.sv-xs-card input[data-xs-variant]')) return;
    /* po obsłudze w cart-upsell.js (plakietka „Ten sam kolor” / „Do kompletu” przeliczona dla nowego koloru) */
    var card = t.closest('.sv-xs-card');
    setTimeout(function () { track('sv_xsell_color', cardData(card)); }, 0);
  }, true);
  /* dodanie z karty (wysłanie formularza; wynik dodania widać po źródle `_sv_src` w zamówieniu) */
  document.addEventListener('submit', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.sv-xs-card');
    if (card) track('sv_xsell_add', cardData(card));
  }, true);
})();
